// extracted by mini-css-extract-plugin
export default {"bodyGrid":"FeedbackReviewDrawer_bodyGrid__pBv03","split":"FeedbackReviewDrawer_split__7pXyF","penIcon":"FeedbackReviewDrawer_penIcon__tH4iC"};